// extracted by mini-css-extract-plugin
export default {"url-arrow":"ArrowLink_url-arrow__GdmFK","featured-url-arrow-wrap":"ArrowLink_featured-url-arrow-wrap__wdFQA","featured-url-arrow":"ArrowLink_featured-url-arrow__LWI+3"};